/** @format */
import { useEffect, useState } from "react";
import { Card, Spinner } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import HRMSApi from "../../api/HRMSApi";
import parse from "html-react-parser";

/* -------------------- Colors -------------------- */
const PRIMARY_COLOR = "#4F6479";
const SECONDARY_COLOR = "#F4F5FA";

/* -------------------- Styles -------------------- */
const toggleButtonStyle = {
    width: "50px",
    position: "fixed",
    top: "50px",
    height: "40px",
    right: "0px",
    zIndex: 1100,
    cursor: "pointer",
    borderTopLeftRadius: "20px",
    borderBottomLeftRadius: "20px",
    backgroundColor: SECONDARY_COLOR,
    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
};

const sidebarBaseStyle = {
    position: "fixed",
    top: 0,
    height: "100vh",
    width: "400px",
    backgroundColor: SECONDARY_COLOR,
    transition: "right 0.3s ease-in-out",
    zIndex: 1000,
    overflowY: "auto",
    padding: "20px",
};

/* -------------------- Components -------------------- */

const ManualSection = ({ html }) => {
    if (!html) return null;

    return (
        <div style={{ fontSize: "14px", color: "#555", lineHeight: "1.6" }}>
            {parse(html)}
        </div>
    );
};

const StepCard = ({ data }) => (
    <Card style={{ border: "none", backgroundColor: "#fff" }}>
        <Card.Body>
            <p>
                <span style={{ color: PRIMARY_COLOR }}>Module Name</span> :{" "}
                <b>{data.sectionName === '/' ? "Home" : data.name}</b>
            </p>
            <hr />
            <ManualSection html={data.contentInformation} />
        </Card.Body>
    </Card>
);

/* -------------------- Main Component -------------------- */

const UserManual = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [manualData, setManualData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();

    const toggleSidebar = () => setIsOpen((prev) => !prev);

    const fetchUserManual = async (section) => {
        try {
            setIsLoading(true);
            const response = await HRMSApi.getUserManual(section);
            if (response.success) {
                setManualData(response.records);
            } else {
                setManualData(null);
            }
        } catch (err) {
            console.error("Manual load failed", err);
            setManualData(null);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchUserManual(location.pathname);
    }, [location.pathname]);

    return (
        <>
            <div onClick={toggleSidebar} style={toggleButtonStyle}>
                {isOpen ? (
                    <i className="fa fa-times-circle" style={{ fontSize: 25, color: PRIMARY_COLOR }} />
                ) : (
                    <i className="fa fa-info-circle" style={{ fontSize: 25, color: PRIMARY_COLOR }} />
                )}
            </div>

            <div
                style={{
                    ...sidebarBaseStyle,
                    right: isOpen ? 0 : "-400px",
                    boxShadow: isOpen ? "-4px 0 12px rgba(0,0,0,0.2)" : "none",
                }}
            >
                <h5 style={{ color: PRIMARY_COLOR }}>User Manual</h5>
                <hr />

                {isLoading && (
                    <div className="d-flex justify-content-center align-items-center mt-4">
                        <Spinner animation="border" style={{ color: PRIMARY_COLOR }} />
                    </div>
                )}

                {!isLoading && manualData && <StepCard data={manualData} />}

                {!isLoading && !manualData && (
                    <p className="text-muted text-center mt-4">
                        No user manual available for this section.
                    </p>
                )}

                <p style={{ fontStyle: "italic", color: "#666", marginTop: "20px" }}>
                    * Click the close icon to hide this panel.
                </p>
            </div>
        </>
    );
};

export default UserManual;
